/**
 * @namespace RewardId
 * @description Defines the unique identifiers for different types of rewards in the system
 * @example
 * ```typescript
 * // Using a reward ID in a query
 * const userRewards = await repository.find({
 *   where: { rewardId: RewardId.LuckyWheel }
 * });
 * ```
 */
export namespace RewardId {
  /** ID for Lucky Wheel rewards */
  export const LuckyWheel = 1n;
  /** ID for Hourly Rakeback rewards */
  export const HourlyRakeback = 2n;
  /** ID for Daily Rakeback rewards */
  export const DailyRakeback = 3n;
  /** ID for Daily Cashback rewards */
  export const DailyCashback = 4n;
  /** ID for Weekly Cashback rewards */
  export const WeeklyCashback = 5n;
  /** ID for Monthly Cashback rewards */
  export const MonthlyCashback = 6n;
  /** ID for Sports Cashback rewards */
  export const SportsCashback = 7n;
  /** ID for Level Up rewards */
  export const LevelUp = 8n;
  /** ID for Roll Competition rewards */
  export const RollCompetition = 9n;
}

/**
 * @type RewardIdType
 * @description Type representing all possible reward ID values
 * @remarks This type is derived from the RewardId namespace and ensures type safety when working with reward IDs
 */
export type RewardIdType = (typeof RewardId)[keyof typeof RewardId];
